import React from "react";

export function StatCard({ label, value, active, onClick, tone = "default", testid, large }) {
  const tones = {
    default: "text-navy",
    hot: "text-red-600",
    qualified: "text-emerald-600",
    education: "text-blue-600",
    low: "text-slate-500",
    ready: "text-gold-dark",
    sent: "text-violet-600",
    won: "text-emerald-700",
    lost: "text-slate-500",
  };
  return (
    <button
      data-testid={testid}
      onClick={onClick}
      className={`text-left rounded-md border bg-card p-5 transition-transform duration-200 hover:-translate-y-1 hover:shadow-md ${
        active ? "border-gold ring-1 ring-gold" : "border-border"
      } ${large ? "md:row-span-1" : ""}`}
    >
      <div className="overline text-muted-foreground mb-2">{label}</div>
      <div className={`font-display font-bold leading-none ${large ? "text-5xl" : "text-3xl"} ${tones[tone]}`}>
        {value ?? 0}
      </div>
    </button>
  );
}
